package app.api

import app.client
import app.model.Stage
import app.plugin.Routing
import dev.fritz2.core.RootStore
import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import io.ktor.http.*
import kotlinx.coroutines.*

class StagesApi : RootStore<List<Stage>>(emptyList(), job = Job()) {
    val handler = handle {
        client.get(Routing.Stages()).body<List<Stage>>()
    }

    val postStage = handle { stages, newStage: Pair<String, String> ->
        val stage = client.post(
            Routing.Stages.New(
                name = newStage.first,
                ordering = newStage.second.toInt()
            )
        ).body<Stage>()
        stages + stage
    }

    val putStage = handle { stages, newStage: Stage ->
        val stage = client.put(
            Routing.Stages.Update(
                id = newStage.id,
                name = newStage.name,
                ordering = newStage.ordering
            )
        ).body<Stage>()
        stages.map { if (it.id == stage.id) stage else it }.sortedBy { it.ordering }
    }

    val deleteStage = handle { stages, id: Int ->
        val resp = client.delete(Routing.Stages.Id(id = id))
        require(resp.status == HttpStatusCode.NoContent)
        stages.filter { stage -> stage.id != id }
    }
}
